import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { Router } from '@angular/router';
import { RoutesPath } from '../../../shared/constants/routes-path';

interface MembershipCard {
  /** COMMON */
  name: string;
  membershipNumber: string;
  tradeLicense: string;
  /** APPROVED-only */
  expiryDate?: string;
  applications?: number;
  activeUsers?: number;
  profileCompletion?: number;
  /** chips & decoration */
  status: 'active' | 'action-required'; // affects bottom corner
  actionRequired?: number;              // chip counter
}
@Component({
  selector: 'app-business-groups-councils',
  imports: [CommonModule, TranslateModule, ButtonComponent],
  templateUrl: './business-groups-councils.component.html',
  styleUrl: './business-groups-councils.component.scss'
})
export class BusinessGroupsCouncilsComponent {
  memberships: MembershipCard[] = [
    {
      name: 'Digital Marketers Group',
      membershipNumber: 'Information & Broadcasting',
      expiryDate: 'Renewal on 13 October 2025',
      applications: 5,
      tradeLicense: 'Chairman',
      activeUsers: 123,
      profileCompletion: 80,
      status: 'active',
    },
    {
      name: 'Media Council',
      membershipNumber: 'Arts & Culture',
      expiryDate: 'Renewal on 23 June 2026',
      applications: 2,
      tradeLicense: 'Vice-Chair',
      activeUsers: 67,
      profileCompletion: 65,
      status: 'action-required',
      actionRequired: 1,
    },
  ];

  pending: MembershipCard[] = [
    {
      name: 'Fabric Trading Group',
      membershipNumber: 'Manufacturing',
      tradeLicense: 'Contact Person',
      activeUsers: 2,
      status: 'active',
    },
  ];
  // This method is used to initialize the class instance using router
  constructor(private router: Router) {

  }

  /* ---- handlers ---- */
  // This method is used to view group using group
  readonly aboutRoute = ['/', RoutesPath.BUSINESS_GROUP, 'about'];
  viewGroup(group: any) {
    this.router.navigate(this.aboutRoute);
  }

  // This method is used to apply service
  applyService() {
    console.log('Apply for service');
  }

  // This method is used to revoke using card
  revoke(card: MembershipCard) {
    console.log('Revoke', card);
  }

  // Static sample data until the business-group list API is supplied.
  groups: BusinessGroupCard[] = [{
    id: 'agri-trading', name: 'Agri Trading', sector: 'Agriculture', role: 'Chairman',
    members: 2, status: 'in-progress', invitation: true
  }];

  respondToInvitation(group: BusinessGroupCard, response: 'approved' | 'rejected'): void {
    // Local demo state; backend approval/rejection will be integrated separately.
    group.response = response;
  }
}
interface BusinessGroupCard {
  id: string;
  name: string;
  sector: string;
  role: string;
  members: number;
  status: 'in-progress' | 'active';
  invitation: boolean;
  response?: 'approved' | 'rejected';
}